import React from "react";
import Link from "next/link";
import {useAuth} from "@/providers/AuthProvider";

export interface BlogViewItemMenuProps {
    postUuidOrSlug: string;
    showEdit?: boolean;
}

export default function BlogViewItemMenu({postUuidOrSlug, showEdit = false}: BlogViewItemMenuProps) {
    const {userCan} = useAuth();

    return (
        <div className="flex flex-row gap-4">
            {showEdit && userCan('POST_POST') && <Link href={`/blog/edit/${postUuidOrSlug}`}>Edit</Link>}
        </div>
    );
}